var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShippingNotice
        ? [
            _c("div", { staticClass: "shipping-notice checkout" }, [
              _c("h4", [_vm._v("Hinweis zur Zustellung:")]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("KrauseSohn::Template.shippingNotice")
                  )
                }
              })
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSilvester
        ? [
            _c("div", { staticClass: "shipping-notice checkout" }, [
              _c("h4", [_vm._v("Hinweis zur Zustellung:")]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("KrauseSohn::Template.silvesterNotice")
                  )
                }
              })
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSofort
        ? [
            _c("div", { staticClass: "shipping-notice checkout" }, [
              _c("h4", [_vm._v("Hinweis zur Zahlungsart:")]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("KrauseSohn::Template.sofortNotice")
                  )
                }
              })
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isFireworkInBasket && _vm.showFireworkNote
        ? [
            _c("div", { staticClass: "shipping-notice checkout" }, [
              _c("h4", [_vm._v("Hinweis für Feuerwerk Kategorie 2:")]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("KrauseSohn::Template.fireworkNotice")
                  )
                }
              }),
              _vm._v(" "),
              _vm.isBasketBelow
                ? _c("div", [
                    _vm._v(
                      "\n          Beachten Sie bitte das der Mindestwarenwert für den Feuerwerkversand bei " +
                        _vm._s(_vm.getMinShippingAmount) +
                        " € liegt.\n        "
                    )
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isBadPlz ? [_vm._m(0)] : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "shipping-notice checkout" }, [
      _c("h4", [_vm._v("Kein Versand Möglich!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Der Versand in das gewählte Postleitzahl-Gebiet ist mit diesem Versanddienstleister leider nicht möglich!"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }